import React, { useState, useEffect } from "react";

const Banner = () => {
    const [isHidden, setIsHidden] = useState(true);

    const handleCloseBanner = () => {
        setIsHidden(true);
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsHidden(false);
        }, 2500);

        return () => {
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div className={`banner ${isHidden ? 'hidden' : ''}`}>
            <span>
                from<br/>
            </span>
            <span className="head">
                &euro;9.99 
                </span>
                <br/>
            <span className="sub">
                per day
            </span>
            {/* <div className="close-banner" onClick={handleCloseBanner}>
                <i className="fa fa-times"></i>
            </div> */}
        </div>
    );
};

export default Banner;


// WEBPACK FOOTER //
// ./src/components/Banner.jsx